import FolderStore from './schema/FolderStore';
import MailboxData from './schema/MailboxData';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import MailboxLoadStateEnum from '../store/schema/MailboxLoadStateEnum';
import { PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID } from '../util/folderConstants';

const getStore = createStore<FolderStore>('folderStore', {
    folderTable: new ObservableMap(),
    mailboxTable: new ObservableMap<string, MailboxData>({
        [PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID]: {
            id: PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID,
            rootFolder: null,
            loadingState: MailboxLoadStateEnum.Uninitialized,
        },
    }),
    sharedFolderUserEmails: [],
});
export const folderStore = getStore();
export default getStore;
